class ContactAccept {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const dataAccept = document.querySelector('[data-accept]').dataset.accept;
    const acceptEle = document.querySelector('.js-acceptance');
    acceptEle.querySelector('a').href = dataAccept;
  }
}
